import React, { useEffect, useState } from 'react';
import * as S from './styles';
import IconWarning from '../../assets/icons/icon-warning-red.png';
import { theme } from '../../styles/theme';
import { BodyPSpan, Auxiliar } from '../../styles/stylesTypography';
import api from '../../services/api';

const AlertRevenue = ({ ...props }) => {
    const [nfPendente, setNfPendente] = useState(0);
    const [envioPendente, setEnvioPendente] = useState(0);
    const [hasPendencias, setHasPendencias] = useState(false);
    const [loaded, setLoaded] = useState(false);

    useEffect(() => {
        const fetchPendencias = async () => {
            try {
                const response = await api.get('/relatorios/homologacoes');
                const rows = response?.data?.data || [];

                // O card só deve aparecer se algum estado vier com pendência
                // (NF ou envio) preenchida. Empresa que não vende defensivos
                // já recebe a pendência de NF zerada pela própria rota.
                setHasPendencias(rows.some((row) => Boolean(row?.pendencia_nf || row?.pendencia_envio)));

                const totals = rows.reduce(
                    (acc, row) => {
                        acc.nfPendente += row?.nf_pendente_count || 0;
                        acc.envioPendente += row?.envio_pendente_count || 0;
                        return acc;
                    },
                    { nfPendente: 0, envioPendente: 0 }
                );

                setNfPendente(totals.nfPendente);
                setEnvioPendente(totals.envioPendente);
            } catch (error) {
                // Falha silenciosa: sem dados reais, o alerta não é exibido
            } finally {
                setLoaded(true);
            }
        };

        fetchPendencias();
    }, []);

    if (!loaded || !hasPendencias) {
        return null;
    }

    const mensagens = [];

    if (nfPendente > 0) {
        mensagens.push(`${nfPendente} receita${nfPendente > 1 ? 's' : ''} com NF pendente`);
    }

    if (envioPendente > 0) {
        mensagens.push(`${envioPendente} receita${envioPendente > 1 ? 's' : ''} pendente${envioPendente > 1 ? 's' : ''} de envio à Defesa`);
    }

    return (
        <S.Container>
            <img src={IconWarning} alt="Alerta" />

            <S.ContentWrapper>
                <S.TextWrapper>
                    <BodyPSpan color={theme.colors.red.Vermelho_erro}>
                        <b>Você tem pendências de exportação para as Defesas Agropecuárias</b>
                    </BodyPSpan>

                    <Auxiliar color={theme.colors.gray.Cinza_2}>
                        <b>{mensagens.join(', ')}.</b>
                    </Auxiliar>
                </S.TextWrapper>

                <S.ResolveButton href="/exportar-defesas">
                    Resolver pendências
                </S.ResolveButton>
            </S.ContentWrapper>
        </S.Container>
    )
}

export default AlertRevenue;
